export default __webpack_public_path__ + "static/media/ata.c81459f7.jpg";